import styled, { css } from 'styled-components';
import { black, darkgrey, grey, inactive, newMark, newPlayerBackground, white } from 'styles/Colors';

export const StyledPlayerSelector = styled.div<{ inputValueLength: number }>`
  &&& {
    overflow: hidden;
    background-color: ${white};
    border-radius: 4px;

    ::placeholder {
      color: ${grey};
      opacity: 0.35;
      font-size: 13px;
    }

    ${(props) =>
      props.inputValueLength > 0 &&
      css`
        .react-autosuggest__container {
          z-index: 10;
        }
      `}
  }
`;

export const StyledSelectedPlayer = styled.div`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const PlayerWrapper = styled.span`
  line-height: 32px;
  font-family: Lato;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.7px;
  border: none;
  margin-bottom: 0;
  display: block;
`;

export const AutocompleteInputLabel = styled.label`
  font-family: Lato;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.7px;
  border: none;
  margin-bottom: 0;
  display: block;
  overflow: hidden;
  background-color: '#fbfbfb';
  border-radius: 8px;

  svg {
    position: absolute;
    width: 32px;
    height: 32px;
    &.greyed-out {
      path {
        fill: ${black};
      }
      opacity: 0.35;
    }
  }
`;

export const AutosuggestWrapper = styled.span`
  .react-autosuggest__container {
    padding: 4px;
    position: absolute;
    background-color: ${white};
    top: 3px;
    left: 25px;
    min-width: 320px;
    width: fit-content;
    z-index: 1;
  }
  .react-autosuggest__input {
    font-family: Lato;
    font-size: 15px;
    font-weight: bold;
    letter-spacing: 0.7px;
    border: none;
    margin-bottom: 0;
    display: block;
  }
  .react-autosuggest__input {
    height: 32px;
  }
  .react-autosuggest__input--focused {
    outline: none;
  }
  .react-autosuggest__container--open {
    z-index: 10;
  }
  .react-autosuggest__suggestions-container--open {
    display: block;
    background-color: ${white};
    font-family: Helvetica, sans-serif;
  }
  .react-autosuggest__suggestions-list {
    margin: 0;
    padding: 0;
    list-style-type: none;
    background-color: #fff;
    overflow-y: scroll;
    max-height: 210px;
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }
  .react-autosuggest__suggestion {
    cursor: default;
    pointer-events: none;
    div {
      cursor: pointer;
      pointer-events: all;
      padding: 8px 16px;
      p {
        margin: 0;
        padding: 0;
        color: ${darkgrey};
        font-size: 13px;
      }
      mark {
        padding: 0;
        background-color: ${newMark};
      }

      &.disabled {
        cursor: default;
        pointer-events: none;
        p {
          color: ${inactive};
        }
      }
    }
  }
  .react-autosuggest__suggestion--highlighted {
    box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.08);
  }
`;

export const Separator = styled.div`
  display: flex;
  color: ${grey};
  align-items: center;
  justify-content: space-around;
`;

export const NewPlayerWrapper = styled.div`
  background-color: ${newPlayerBackground};
  border-radius: 8px;
  padding: 12px 18px;
`;
